import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=04bf4572&scoped=true&"
import script from "./CreateReport.vue?vue&type=script&lang=js&"
export * from "./CreateReport.vue?vue&type=script&lang=js&"
import style0 from "./CreateReport.vue?vue&type=style&index=0&id=04bf4572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf4572",
  null
  
)

export default component.exports